export default {
  slug: "jetbrains-ai",
  code: "AI",
  label: "JetBrains AI",
  shortLabel: "AI",
  hideProductName: true,
  logoFamily: "ai",
};
